import { createSelector } from 'reselect';

const selectBudgets = (state: any) => state.budgets;

export const selectBudgetsCurrentItem = createSelector([selectBudgets], (budgets) => budgets.current);

export const selectBudgetsListItems = createSelector([selectBudgets], (budgets) => budgets.list);

export const selectBudgetsItemById = (itemId: any) =>
    createSelector(selectBudgetsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBudgetsQueryItems = createSelector([selectBudgets], (budgets) => budgets.query);

export const selectBudgetsCreatedItem = createSelector([selectBudgets], (budgets) => budgets.create);

export const selectBudgetsUpdatedItem = createSelector([selectBudgets], (budgets) => budgets.update);

export const selectBudgetsReadItem = createSelector([selectBudgets], (budgets) => budgets.read);

export const selectBudgetsDeletedItem = createSelector([selectBudgets], (budgets) => budgets.delete);

export const selectBudgetsSearchedItems = createSelector([selectBudgets], (budgets) => budgets.search);

export const selectBudgetsItemsCount = createSelector([selectBudgets], (budgets) => budgets.count);

export const selectBudgetsItemsFilter = createSelector([selectBudgets], (budgets) => budgets.filter);